import { buildApiUrl } from "../../config";
import { fetchWithRetry, readApiError } from "../../utils";
import { withCredentials } from "../../services/apiClient";

import type { SlideLibraryListOptions } from "./types";
import { readJsonResponse } from "../common/http";

export { readJsonResponse } from "../common/http";

function appendListOptions(searchParams: URLSearchParams, options: SlideLibraryListOptions = {}): void {
  if (typeof options.page === "number") {
    searchParams.set("page", String(options.page));
  }
  if (typeof options.pageSize === "number") {
    searchParams.set("page_size", String(options.pageSize));
  }
  if (options.tags?.length) {
    searchParams.set("tags", options.tags.join(","));
  }
  if (typeof options.favourite === "boolean") {
    searchParams.set("favourite", String(options.favourite));
  }
}

export function buildPathWithQuery(path: string, options?: SlideLibraryListOptions): string {
  const searchParams = new URLSearchParams();
  appendListOptions(searchParams, options);
  const queryString = searchParams.toString();
  return queryString ? `${path}?${queryString}` : path;
}

export function readListPayload(payload: unknown): Record<string, unknown> {
  const root = payload && typeof payload === "object" ? (payload as Record<string, unknown>) : {};
  const data = root.data;
  if (data && typeof data === "object") {
    return data as Record<string, unknown>;
  }
  return root;
}

export async function fetchSlideLibraryJson<T>(
  path: string,
  init: RequestInit,
  retryLabel: string
): Promise<T> {
  const response = await fetchWithRetry(buildApiUrl(path), withCredentials(init), 1, retryLabel);
  if (!response.ok) {
    throw new Error(await readApiError(response));
  }
  return (await readJsonResponse(response)) as T;
}

export function isEmptyLibraryResponse(response: Response): boolean {
  return response.status === 404;
}
